export default __webpack_public_path__ + "static/Sticker_A5_USERS_AM-3db062eb7d101de8d8caa2a2e30a7164.svg";